import type { ReactNode } from 'react'

type ButtonGroupProps = {
  children: ReactNode
}

export const ButtonGroup = (props: ButtonGroupProps) => {
  const { children } = props
  return (
    <div className='flex justify-end'>
      <div className='flex gap-2'>{children}</div>
    </div>
  )
}
